export const ModeWidth = '100px';
export const MontantWidth = '100px';
export const ReferenceWidth = '170px';

export const DateEnregistrementWidth = '120px';
export const TransactionCBWidth = '120px';
export const FactureLieeWidth = '120px';
export const ActionWidth = '50px';
export const NoteWidth = `calc(100% - ${ModeWidth} - ${MontantWidth} - ${ReferenceWidth} - ${DateEnregistrementWidth} - ${TransactionCBWidth} - ${FactureLieeWidth})`;

export const ReferenceWidthMobile = `250px`;
export const NoteWidthMobile = `calc(100% - ${ModeWidth} - ${MontantWidth} - ${ReferenceWidthMobile})`;

export const DateEnregistrementWidthMobile = '250px';
export const TransactionCBWidthMobile = '150px';
export const FactureLieeWidthMobile = '40%';
export const ActionWidthMobile = `calc(100% - ${DateEnregistrementWidthMobile} - ${FactureLieeWidthMobile}- ${TransactionCBWidthMobile})`;

export const ModeLibelle = 'Mode';
export const MontantLibelle = 'Montant';
export const NoteLibelle = 'Note';
export const ReferenceLibelle = 'Référence';
export const DateEnregistrementLibelle = 'Date';
export const TransactionCBLibelle = 'Transaction';
export const FactureLieeLibelle = 'Facture liée';
// export const DocumentsLibelle = 'Documents';
